import React, {
  useContext,
  useEffect,
  useCallback,
  Suspense,
  lazy,
} from "react";
import { getUsersCards } from "./helpers/helpers";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import theme from "./theme";
import { Routes, Route } from "react-router-dom";
import AppContext from "./context/index";

// Lazy load components
const Homepage = lazy(() => import("./components/Homepage"));
const SetCompleteness = lazy(() => import("./components/SetCompleteness"));
const Navigation = lazy(() => import("./components/Navigation"));
const CollectionContainer = lazy(() =>
  import("./components/CollectionContainer")
);

function App() {
  const user = "jinky32";
  const { example, setExample } = useContext(AppContext);

  const getCards = useCallback(
    async (username) => {
      try {
        const usersCards = await getUsersCards(username);

        setExample((prevcontext) => {
          return {
            ...prevcontext,
            ownedCards: usersCards.ownedCards,
            wantedCards: usersCards.wantedCards,
          };
        });
      } catch (err) {
        throw err;
      }
    },
    [setExample]
  );

  let ownedCollectionTypes = [];
  let wantedCOllectionTypes = [];

  example.ownedCards.forEach((thisRow) => {
    if (
      ownedCollectionTypes.find(
        (otherRow) =>
          thisRow["brand"] === otherRow["brand"] &&
          thisRow["manufacturer"] === otherRow["manufacturer"] &&
          thisRow["year"] === otherRow["year"]
      ) === undefined
    ) {
      ownedCollectionTypes.push(thisRow);
    }
  });

  example.wantedCards.forEach((thisRow) => {
    if (
      wantedCOllectionTypes.find(
        (otherRow) =>
          thisRow["brand"] === otherRow["brand"] &&
          thisRow["manufacturer"] === otherRow["manufacturer"] &&
          thisRow["year"] === otherRow["year"]
      ) === undefined
    ) {
      wantedCOllectionTypes.push(thisRow);
    }
  });

  useEffect(() => {
    getCards(user);
  }, [user, getCards]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="xl">
        <Suspense
          fallback={
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <CircularProgress />
            </Box>
          }
        >
          <Navigation ownedCollectionNav={ownedCollectionTypes} />
          <Box sx={{ my: 4 }}>
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="home" element={<Homepage />} />
              <Route path="set-completeness" element={<SetCompleteness />} />
              <Route
                path="own/year/:year/brand/:brand"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/availability/:forTrade"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/brand/:brand"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/brand/:brand/variation/:variation"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/:card_id"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/career-stage/:career_stage"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/card_title/:card_title"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/forTrade/:forTrade"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/team/:team"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/type/:id"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/series/:series"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/variation/:variation"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/year/:year"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/year/:year/brand/:brand"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/year/:year/series/:series"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/year/:year/brand/:brand/variation/:variation"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="own/year/:year/variation/:variation"
                element={<CollectionContainer status="Own" />}
              />
              <Route
                path="want"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/availability/:forTrade"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/brand/:brand"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/brand/:brand/variation/:variation"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/:card_id"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/career-stage/:career_stage"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/card_title/:card_title"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/forTrade/:forTrade"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/team/:team"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/type/:id"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/series/:series"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/variation/:variation"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/year/:year"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/year/:year/brand/:brand"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/year/:year/series/:series"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/year/:year/brand/:brand/variation/:variation"
                element={<CollectionContainer status="Want" />}
              />
              <Route
                path="want/year/:year/variation/:variation"
                element={<CollectionContainer status="Want" />}
              />
            </Routes>
          </Box>
        </Suspense>
      </Container>
    </ThemeProvider>
  );
}

export default App;
